import LanguageQuickSelect from './LanguageQuickSelect'

export default LanguageQuickSelect
// eslint-disable-next-line import/export
export * from './LanguageQuickSelect'
